import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de.json";
import en from "./locales/en.json";
import esES from "./locales/es-ES.json";
import esMX from "./locales/es-MX.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import pl from "./locales/pl.json";
import ptBR from "./locales/pt-BR.json";
import ptPT from "./locales/pt-PT.json";
import ru from "./locales/ru.json";
import uk from "./locales/uk.json";
import { findLanguage, LANGUAGE_CODES } from "./i18n/languages";

const STORAGE_KEY = "uramaks-lang";

function getInitialLanguage() {
  if (typeof window === "undefined") return "en";

  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && LANGUAGE_CODES.includes(stored)) return stored;

  const browser = (navigator.language || "en").toLowerCase();
  const exact = LANGUAGE_CODES.find((code) => code.toLowerCase() === browser);
  if (exact) return exact;

  const prefix = LANGUAGE_CODES.find((code) => browser.startsWith(code.toLowerCase()));
  if (prefix) return prefix;

  const base = browser.split("-")[0];
  const baseMatch = LANGUAGE_CODES.find((code) => code.toLowerCase() === base);
  if (baseMatch) return baseMatch;

  return "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "es-ES": { translation: esES },
    "es-MX": { translation: esMX },
    it: { translation: it },
    de: { translation: de },
    pl: { translation: pl },
    "pt-BR": { translation: ptBR },
    "pt-PT": { translation: ptPT },
    ru: { translation: ru },
    uk: { translation: uk },
    fr: { translation: fr },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  if (typeof window === "undefined") return;
  const language = findLanguage(lng);
  window.localStorage.setItem(STORAGE_KEY, language.code);
  document.documentElement.lang = language.locale;
});

export default i18n;
